module.exports = __webpack_public_path__ + "img/aqualium_image.3bb1f212.jpg";